var _defs, _rect, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40493",
    "data-name": "Group 40493",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214.016,
    height: 70,
    viewBox: "0 0 214.016 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72730",
    "data-name": "Path 72730",
    d: "M742.25,200.417l-9.647-5.573s-17.58-10.153-18.615-10.749-2.063-.235-2.063,1.012v43.788c0,.937.737,1.341,1.635.82s19.043-11,19.043-11l9.647-5.569,9.278-5.357c1.086-.627.984-1.49.063-1.984S742.25,200.417,742.25,200.417Z",
    transform: "translate(-711.925 -183.814)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#257db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#3c8fb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#73bcb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89cebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51bfac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee899"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb403d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#d54251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#9e4787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#f9b075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc674"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23566",
    "data-name": "Rectangle 23566",
    width: 214.016,
    height: 70,
    rx: 5,
    fill: "#231f20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAY",
    transform: "translate(16.053 14.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40488",
    "data-name": "Group 40488",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72726",
    "data-name": "Path 72726",
    d: "M711.925,183.627v47.408l23.906-23.7Z",
    transform: "translate(-711.925 -184.363)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72727",
    "data-name": "Path 72727",
    d: "M742.252,201.093l-9.65-5.571-20.677-11.939v.173l23.906,23.7Z",
    transform: "translate(-711.925 -184.492)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72728",
    "data-name": "Path 72728",
    d: "M711.925,213.375v.173L732.6,201.609l9.65-5.571-6.421-6.366Z",
    transform: "translate(-711.925 -166.703)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72729",
    "data-name": "Path 72729",
    d: "M724.442,188.048l-6.421,6.367,6.421,6.366,11.028-6.367Z",
    transform: "translate(-694.115 -171.447)",
    fill: "url(#linear-gradient-4)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40489",
    "data-name": "Group 40489",
    transform: "translate(160.141 26.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72731",
    "data-name": "Path 72731",
    d: "M755.084,202.684a5.989,5.989,0,0,1-2.459-.5,4.651,4.651,0,0,1-1.867-1.529h-.153a18.276,18.276,0,0,1,.153,2.29v5.674h-2.09V188.645h1.7l.29,1.886h.1a4.813,4.813,0,0,1,1.875-1.635,5.654,5.654,0,0,1,2.451-.506,5.11,5.11,0,0,1,4.235,1.874,9.981,9.981,0,0,1-.027,10.537A5.1,5.1,0,0,1,755.084,202.684Zm-.3-12.518a3.693,3.693,0,0,0-3.055,1.169,6,6,0,0,0-.969,3.725v.463a6.9,6.9,0,0,0,.969,4.161,3.689,3.689,0,0,0,3.106,1.251,3.23,3.23,0,0,0,2.8-1.447,6.868,6.868,0,0,0,1.012-3.988,6.612,6.612,0,0,0-1.012-3.957A3.335,3.335,0,0,0,754.781,190.166Z",
    transform: "translate(-748.668 -182.857)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72732",
    "data-name": "Path 72732",
    d: "M754.554,206.551h-2.09V186.979h2.09Z",
    transform: "translate(-737.578 -186.979)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72733",
    "data-name": "Path 72733",
    d: "M763.143,202.409l-.416-1.961h-.1a5.8,5.8,0,0,1-2.059,1.753,6.2,6.2,0,0,1-2.561.463A4.6,4.6,0,0,1,754.8,201.6a3.854,3.854,0,0,1-1.165-3.008q0-4.171,6.678-4.376l2.341-.074v-.855a3.483,3.483,0,0,0-.7-2.4,2.868,2.868,0,0,0-2.231-.776,9.08,9.08,0,0,0-3.9,1.059l-.643-1.6a9.961,9.961,0,0,1,2.235-.867,9.737,9.737,0,0,1,2.435-.314,5.261,5.261,0,0,1,3.655,1.094,4.568,4.568,0,0,1,1.188,3.51v9.408Zm-4.718-1.471a4.244,4.244,0,0,0,3.063-1.067,3.967,3.967,0,0,0,1.114-3v-1.247l-2.086.09a7.572,7.572,0,0,0-3.592.773,2.338,2.338,0,0,0-1.1,2.133,2.141,2.141,0,0,0,.687,1.722A2.833,2.833,0,0,0,758.425,200.938Z",
    transform: "translate(-734.163 -182.836)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72734",
    "data-name": "Path 72734",
    d: "M756.762,188.455H759l3.02,7.863a30.617,30.617,0,0,1,1.231,3.886h.1q.165-.641.682-2.2t3.416-9.553H769.7l-5.925,15.7a7.839,7.839,0,0,1-2.059,3.3,4.366,4.366,0,0,1-2.886.976,8.46,8.46,0,0,1-1.886-.216v-1.671a7.43,7.43,0,0,0,1.545.149,3.188,3.188,0,0,0,3.071-2.416l.769-1.961Z",
    transform: "translate(-725.021 -182.667)",
    fill: "#f9f9f9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40491",
    "data-name": "Group 40491",
    transform: "translate(64.946 25.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72735",
    "data-name": "Path 72735",
    d: "M748.454,189.555a4.865,4.865,0,0,1,2.047,3.894c0,2.133-1.212,3.145-2.424,4.094a2.03,2.03,0,0,0-.808,1.416,1.583,1.583,0,0,0,.749,1.239l1.039.8c1.271,1.071,2.423,2.051,2.423,4.039,0,2.714-2.627,5.451-7.584,5.451-4.184,0-6.2-1.988-6.2-4.125a4.155,4.155,0,0,1,2.219-3.518,12.427,12.427,0,0,1,5.51-1.326,3.013,3.013,0,0,1-.867-1.961,2.641,2.641,0,0,1,.286-1.125c-.318.027-.631.059-.922.059a4.562,4.562,0,0,1-4.788-4.529,5.188,5.188,0,0,1,1.847-3.863,7.854,7.854,0,0,1,5.165-1.588h5.937l-1.847,1.039Zm-2.047,12.8a4.922,4.922,0,0,0-.663-.027,11.564,11.564,0,0,0-3.031.463,3.239,3.239,0,0,0-2.479,2.969c0,2.047,1.988,3.521,5.074,3.521,2.769,0,4.239-1.329,4.239-3.118C749.548,204.692,748.6,203.92,746.407,202.359Zm.835-5.478a2.909,2.909,0,0,0,.718-2.106c0-2.075-1.239-5.306-3.631-5.306a2.7,2.7,0,0,0-2.02.953,3.326,3.326,0,0,0-.635,2.133c0,1.933,1.125,5.133,3.608,5.133A2.945,2.945,0,0,0,747.242,196.881Z",
    transform: "translate(-685.525 -180.947)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72736",
    "data-name": "Path 72736",
    d: "M741.042,202.2a6.8,6.8,0,0,1-7.023-6.8,7.133,7.133,0,0,1,7.459-7,6.729,6.729,0,0,1,6.878,6.8A7.035,7.035,0,0,1,741.042,202.2Zm3.6-2.333a5.221,5.221,0,0,0,.863-3.2c0-2.533-1.208-7.372-4.776-7.372a4.016,4.016,0,0,0-2.592.98,4.364,4.364,0,0,0-1.325,3.514c0,2.851,1.412,7.541,4.894,7.541A3.678,3.678,0,0,0,744.643,199.871Z",
    transform: "translate(-696.271 -181.251)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72737",
    "data-name": "Path 72737",
    d: "M737.066,202.2a6.8,6.8,0,0,1-7.027-6.8,7.136,7.136,0,0,1,7.459-7,6.733,6.733,0,0,1,6.882,6.8A7.035,7.035,0,0,1,737.066,202.2Zm3.6-2.333a5.221,5.221,0,0,0,.863-3.2c0-2.533-1.208-7.372-4.78-7.372a4.031,4.031,0,0,0-2.592.98,4.36,4.36,0,0,0-1.322,3.514c0,2.851,1.408,7.541,4.894,7.541A3.683,3.683,0,0,0,740.667,199.871Z",
    transform: "translate(-707.898 -181.251)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72738",
    "data-name": "Path 72738",
    d: "M744.334,206.609l-4.137.953a30.469,30.469,0,0,1-4.776.49c-7.988,0-11.027-5.874-11.027-10.478,0-5.616,4.31-10.823,11.694-10.823a16.685,16.685,0,0,1,4.427.608,11.224,11.224,0,0,1,3.819,1.8l-2.4,2.286-1.016.231.726-1.161a8.282,8.282,0,0,0-6.2-2.718c-4.572,0-8.015,3.474-8.015,8.541,0,5.439,3.937,10.561,10.243,10.561a8.629,8.629,0,0,0,3.678-.721v-4.659l-4.369.231L739.3,200.5h6.137l-.753.722a.69.69,0,0,0-.29.463c-.031.263-.059,1.1-.059,1.392Z",
    transform: "translate(-724.393 -186.107)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72739",
    "data-name": "Path 72739",
    d: "M747.354,206.252c-.957-.086-1.157-.259-1.157-1.388V188.48l.016-.188c.118-1.012.408-1.184,1.306-1.706h-4.141l-2.172,1.043h2.211V205.5c0,.58-.114.667-.78,1.533h5.121l1.071-.635C748.338,206.339,747.844,206.311,747.354,206.252Z",
    transform: "translate(-675.276 -186.586)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72740",
    "data-name": "Path 72740",
    d: "M753.591,201.179c-.314.172-.631.376-.945.518a6.683,6.683,0,0,1-2.792.545,6.139,6.139,0,0,1-3.823-1.122,7.435,7.435,0,0,1-2.929-6.067,6.516,6.516,0,0,1,6.584-6.639,5.567,5.567,0,0,1,2.961.808,4.729,4.729,0,0,1,2.008,2.843L747.9,194.8l-2.212.172c.718,3.651,3.188,5.776,5.922,5.776a7.435,7.435,0,0,0,3.506-1Zm-2.7-8.569c.545-.2.831-.372.831-.776a2.852,2.852,0,0,0-2.847-2.471c-1.149,0-3.306.89-3.306,4,0,.49.059,1,.086,1.525Z",
    transform: "translate(-669.737 -181.245)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40490",
    "data-name": "Group 40490",
    transform: "translate(85.771 7.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72741",
    "data-name": "Path 72741",
    d: "M747.124,188.61v1.9h-.231v-1.9h-.627v-.2h1.486v.2Z",
    transform: "translate(-746.265 -188.414)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72742",
    "data-name": "Path 72742",
    d: "M748.321,190.508v-1.914h-.008l-.584,1.914h-.18l-.592-1.914h0v1.914h-.212v-2.094h.361l.533,1.694h.008l.522-1.694h.365v2.094Z",
    transform: "translate(-744.877 -188.414)",
    fill: "#f9f9f9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40492",
    "data-name": "Group 40492",
    transform: "translate(64.993 14.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72743",
    "data-name": "Path 72743",
    d: "M730.107,189.672h-1.439a9.681,9.681,0,0,0-.408-1.682h-2.078a8.73,8.73,0,0,0-.424,1.682h-1.353c0-.118.353-1.078,1.051-2.878a23.109,23.109,0,0,0,1.051-2.972h1.7a25.325,25.325,0,0,0,.949,2.929A25.683,25.683,0,0,1,730.107,189.672Zm-2.079-2.541c-.51-1.545-.769-2.38-.769-2.506h-.071c0,.114-.267.953-.8,2.506Z",
    transform: "translate(-724.405 -183.684)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72744",
    "data-name": "Path 72744",
    d: "M730.93,189.672h-1.11a10.718,10.718,0,0,0-1.24-1.945,10.851,10.851,0,0,1-1.474-2.541h-.071a15.962,15.962,0,0,1,.114,1.78q0,1.112.063,2.706h-1.106q.065-1.394.067-3.063,0-1.641-.067-2.788h1.333a8.58,8.58,0,0,0,1.11,1.9,11.357,11.357,0,0,1,1.361,2.4h.067a16.322,16.322,0,0,1-.11-1.8c0-.812-.02-1.647-.063-2.5h1.125q-.065,1.112-.063,2.788Q730.868,188.3,730.93,189.672Z",
    transform: "translate(-719.433 -183.684)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72745",
    "data-name": "Path 72745",
    d: "M732.682,186.563a3.325,3.325,0,0,1-.82,2.231,2.856,2.856,0,0,1-2.29.953c-.443,0-1.055-.02-1.835-.055q.059-1.359.059-3.063,0-1.635-.059-2.788h.788c.129,0,.322-.008.576-.016s.42-.012.5-.012a3.021,3.021,0,0,1,2.353.808A2.8,2.8,0,0,1,732.682,186.563Zm-1.228.192a2.17,2.17,0,0,0-.5-1.451,1.909,1.909,0,0,0-1.537-.592,4.525,4.525,0,0,0-.529.039c.027.6.043,1.227.043,1.878,0,.718.016,1.427.043,2.133a3.3,3.3,0,0,0,.584.055,1.693,1.693,0,0,0,1.431-.6A2.292,2.292,0,0,0,731.455,186.755Z",
    transform: "translate(-714.671 -183.704)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72746",
    "data-name": "Path 72746",
    d: "M734.059,189.692h-1.33a8.9,8.9,0,0,0-.8-1.965,1.059,1.059,0,0,0-.9-.373c-.173,0-.337,0-.5,0,0,.769.015,1.549.039,2.333h-1.247q.058-1.359.059-3.063,0-1.635-.059-2.788h.776c.09,0,.278-.008.565-.016s.549-.012.792-.012q2.064,0,2.063,1.412a1.58,1.58,0,0,1-1.177,1.557v.067a1.417,1.417,0,0,1,.8.71A15.771,15.771,0,0,1,734.059,189.692Zm-1.686-4.137c0-.6-.384-.894-1.149-.894a4.2,4.2,0,0,0-.749.063c.035.467.051,1.071.051,1.816.165.008.3.012.42.012Q732.375,186.551,732.373,185.555Z",
    transform: "translate(-710.04 -183.704)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72747",
    "data-name": "Path 72747",
    d: "M736.436,186.739a3.23,3.23,0,0,1-.847,2.29,2.738,2.738,0,0,1-2.09.906,2.638,2.638,0,0,1-1.984-.835,2.924,2.924,0,0,1-.8-2.118,3.235,3.235,0,0,1,.843-2.286,2.74,2.74,0,0,1,2.09-.91,2.652,2.652,0,0,1,1.988.831A2.941,2.941,0,0,1,736.436,186.739Zm-1.239.129a2.312,2.312,0,0,0-.482-1.522,1.488,1.488,0,0,0-1.188-.584,1.373,1.373,0,0,0-1.114.588,2.349,2.349,0,0,0-.458,1.486,2.311,2.311,0,0,0,.482,1.522,1.479,1.479,0,0,0,1.184.588,1.368,1.368,0,0,0,1.117-.592A2.349,2.349,0,0,0,735.2,186.868Z",
    transform: "translate(-705.973 -183.786)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72748",
    "data-name": "Path 72748",
    d: "M733.768,189.672H732.5q.053-1.394.055-3.063,0-1.641-.055-2.788h1.271q-.059,1.129-.059,2.788C733.709,187.739,733.728,188.762,733.768,189.672Z",
    transform: "translate(-700.764 -183.684)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72749",
    "data-name": "Path 72749",
    d: "M738.166,186.563a3.32,3.32,0,0,1-.816,2.231,2.86,2.86,0,0,1-2.294.953c-.443,0-1.055-.02-1.835-.055q.059-1.359.059-3.063,0-1.635-.059-2.788h.788c.129,0,.322-.008.576-.016s.42-.012.5-.012a3.021,3.021,0,0,1,2.353.808A2.8,2.8,0,0,1,738.166,186.563Zm-1.228.192a2.15,2.15,0,0,0-.5-1.451,1.9,1.9,0,0,0-1.537-.592,4.532,4.532,0,0,0-.53.039c.028.6.043,1.227.043,1.878,0,.718.016,1.427.047,2.133a3.235,3.235,0,0,0,.584.055,1.7,1.7,0,0,0,1.431-.6A2.313,2.313,0,0,0,736.938,186.755Z",
    transform: "translate(-698.649 -183.704)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72750",
    "data-name": "Path 72750",
    d: "M740.931,189.672h-1.439a9.3,9.3,0,0,0-.407-1.682H737.01a8.72,8.72,0,0,0-.423,1.682h-1.353q0-.177,1.047-2.878a22.424,22.424,0,0,0,1.051-2.972h1.7a24.946,24.946,0,0,0,.953,2.929A26.084,26.084,0,0,1,740.931,189.672Zm-2.074-2.541a25,25,0,0,1-.769-2.506h-.074a25.768,25.768,0,0,1-.8,2.506Z",
    transform: "translate(-692.771 -183.684)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72751",
    "data-name": "Path 72751",
    d: "M741.2,185.371a1.757,1.757,0,0,1-.8,1.588,3.555,3.555,0,0,1-1.957.514,2.634,2.634,0,0,1-.3-.012c0,.565.016,1.306.047,2.231h-1.262q.058-1.3.059-3.063,0-1.618-.059-2.788h.784c.11,0,.322-.008.639-.016s.584-.012.816-.012a2.564,2.564,0,0,1,1.443.384A1.311,1.311,0,0,1,741.2,185.371Zm-1.161.247c0-.639-.424-.961-1.275-.961a3.777,3.777,0,0,0-.675.067c.031.569.051,1.208.051,1.925.075,0,.161.008.259.008Q740.046,186.657,740.044,185.618Z",
    transform: "translate(-687.801 -183.704)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72752",
    "data-name": "Path 72752",
    d: "M742.58,185.371a1.757,1.757,0,0,1-.8,1.588,3.569,3.569,0,0,1-1.961.514,2.556,2.556,0,0,1-.3-.012c0,.565.016,1.306.047,2.231h-1.262q.058-1.3.059-3.063,0-1.618-.059-2.788h.78c.114,0,.325-.008.639-.016s.588-.012.82-.012a2.564,2.564,0,0,1,1.443.384A1.311,1.311,0,0,1,742.58,185.371Zm-1.161.247c0-.639-.424-.961-1.275-.961a3.741,3.741,0,0,0-.675.067c.031.569.047,1.208.047,1.925.074,0,.165.008.263.008Q741.421,186.657,741.419,185.618Z",
    transform: "translate(-683.784 -183.704)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72753",
    "data-name": "Path 72753",
    d: "M745.908,186.739a3.227,3.227,0,0,1-.843,2.29,2.743,2.743,0,0,1-2.09.906,2.641,2.641,0,0,1-1.988-.835,2.925,2.925,0,0,1-.8-2.118,3.22,3.22,0,0,1,.847-2.286,2.734,2.734,0,0,1,2.09-.91,2.643,2.643,0,0,1,1.984.831A2.94,2.94,0,0,1,745.908,186.739Zm-1.239.129a2.311,2.311,0,0,0-.482-1.522,1.475,1.475,0,0,0-1.184-.584,1.368,1.368,0,0,0-1.114.588,2.349,2.349,0,0,0-.459,1.486,2.312,2.312,0,0,0,.482,1.522,1.479,1.479,0,0,0,1.184.588,1.361,1.361,0,0,0,1.114-.592A2.349,2.349,0,0,0,744.668,186.868Z",
    transform: "translate(-678.301 -183.786)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72754",
    "data-name": "Path 72754",
    d: "M746.792,189.672h-1.11a10.82,10.82,0,0,0-1.235-1.945,10.7,10.7,0,0,1-1.475-2.541H742.9a15.077,15.077,0,0,1,.114,1.78q0,1.112.063,2.706h-1.106c.047-.929.067-1.949.067-3.063,0-1.094-.02-2.023-.067-2.788h1.337a8.4,8.4,0,0,0,1.11,1.9,11.274,11.274,0,0,1,1.357,2.4h.067a17.257,17.257,0,0,1-.106-1.8c0-.812-.024-1.647-.062-2.5h1.121q-.065,1.112-.063,2.788Q746.73,188.3,746.792,189.672Z",
    transform: "translate(-673.092 -183.684)",
    fill: "#f9f9f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/Google play.a7696222f45fda99e03508a01d0dee4c.svg";
export { ForwardRef as ReactComponent };